export function formatDeliveryDate(isoDate) {
  if (!isoDate) return "—";
  try {
    return new Date(isoDate).toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return isoDate;
  }
}

export function formatDeliveryDateTime(isoDateTime) {
  if (!isoDateTime) return "—";
  try {
    return new Date(isoDateTime).toLocaleString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  } catch {
    return isoDateTime;
  }
}

export function resolveDeliveryDateTime(product = {}) {
  return product.expectedDeliveryDateTime || product.expectedDeliveryDate || "";
}
